<template>
  <div class="text-sm">
    <p class="mt-6"><b>2024.12.30</b> - Представляем... affinities героев!</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        AFFINITIES ГЕРОЕВ: Теперь ваши герои 30+ уровня могут тратить очки способностей на улучшения "Affinity",
        дающие им бонусный урон или снижение урона против определённых классов героев
        или типов монстров. Найдите интерфейс Affinities в левом нижнем углу
        экрана редактирования способностей!
      </li>
      <li>
        Исправлен серьёзный баг, из-за которого способности мобов Пещеры всегда были 0 уровня. Так что
        вы обнаружите, что мобы стали намного опаснее на той глубине, где вы уже находитесь.
        Поскольку это, вероятно, заставит некоторых игроков перезапустить Пещеры с
        первого уровня, я даю всем
        <span style="color: cyan">1,000 Пыльца пикси</span> в качестве компенсации.
      </li>
      <li>
        Баланс - увеличено масштабирование урона Пылающие руки:<code
          >65 + L*(Le/5 + Ma/7 + De/10)</code
        >
        --> <code>65 + Уровень*(Об/3 + Ма/5 + Лв/7)</code>
      </li>
    </ul>
  </div>
</template>
